import type { DrpSource } from "common/models/types";

/**
 * DRP 원천 선택(spec 설계 결정 4).
 *
 * 수정본(`reviewResultEdited`)이 truthy면 수정본 HTML, 아니면 원본(`reviewResult`) MD를 쓴다.
 * 빈 문자열(수정본 삭제)·null·미지정은 모두 "수정본 없음"으로 보고 원본으로 떨어진다.
 * 원본/수정본 토글 상태와 무관하게 수정본 우선(화면 기본 규칙과 동일).
 *
 * 원천 종류(`kind`)는 저장 시 `context.drpSource`로 쓴다(설계 결정 13).
 */
export type DrpSourceSelection =
  | { kind: "edited"; html: string }
  | { kind: "original"; md: string }
  | { kind: "none" };

export interface DrpSourceReview {
  reviewResult?: string | null;
  reviewResultEdited?: string | null;
}

export function selectDrpSource(review: DrpSourceReview): DrpSourceSelection {
  const edited = review.reviewResultEdited;
  if (edited) {
    return { kind: "edited", html: edited };
  }
  const original = review.reviewResult;
  if (original) {
    return { kind: "original", md: original };
  }
  return { kind: "none" };
}

/** 원천 종류를 저장용 `drpSource` 값으로 환산한다. */
export function drpSourceOf(selection: DrpSourceSelection): DrpSource {
  if (selection.kind === "edited") return "edited";
  if (selection.kind === "original") return "original";
  return "none";
}
